import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Msgpic from "../../assets/user.png";
import { MessageDetailApi } from "../../Utils/Api/MessageDetails";
import { useParams, useNavigate } from "react-router-dom";
import Moment from "moment";
import {
  addDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { db, auth } from "../../Firebase";
import { getUser } from "../../Utils/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { getChatFlagOrderSlice } from "../../redux/ChatFlagSlice";

const OrderRelated = ({ props, flagFetchHandler, SetChatList }) => {
  const navigate = useNavigate();
  const parameter = useParams();
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allMessages, setAllMessages] = useState([]);
  const [selectChannelLog, setselectedChannelLog] = useState("");

  const userData = getUser();
  const userId = userData.user_id;
  const Handler = async () => {
    setLoading(true);
    const ChatHistory = await MessageDetailApi(() => {
      navigate("/");
    });
    let chatList = ChatHistory.data;
    for (let key in chatList) {
      getChatCount(chatList[key]["channel_id"]);
    }
    setChatHistory(chatList);
    SetChatList(chatList);
    setLoading(false);
  };
  useEffect(() => {
    Handler();
  }, []);

  const dispatch = useDispatch();

  function handleClick(chat_id) {
    navigate(`/messages/${chat_id.channel_id.toString()}`, {
      state: {
        productName: chat_id.product_name,
        businessName: chat_id.business_name,
        profileImage: chat_id.eu_profile_image,
        firstName: chat_id.end_user_first_name,
      },
    });
    localStorage.setItem("eu_userId", chat_id.endUser_id);
    setselectedChannelLog(chat_id.channel_id);
    dispatch(getChatFlagOrderSlice(true));
  }
  const ReduxData = useSelector((state) => state.ChatFlag);

  const OrderFlag = ReduxData.ChatFlagOrder;

  const getChatCount = (com_id) => {
    const unsub = onSnapshot(
      query(collection(db, com_id), orderBy("timestamp")),
      (snapshot) => {
        setAllMessages((allMessages) => [
          ...allMessages,
          snapshot.docs.map((doc) => ({
            com_id: com_id,
            id: doc.id,
            messages: doc.data(),
            read: doc.data().read,
            userId: doc.data().messageUserId,
          })),
        ]);
      }
    );
    return unsub;
  };
  const msg_count = [];

  allMessages.map((item2, index) => {
    const unreadMessages = item2.filter(
      (message) => message.read === false && message.userId !== userId
    );
    msg_count[index] = unreadMessages.length;
  });

  return (
    <>
      <div style={{ cursor: "pointer" }}>
        {chatHistory && true ? (
          chatHistory.map((item, index) => {
            return item.chat_type == 1 ? (
              <div
                className={
                  selectChannelLog === item.channel_id && OrderFlag === true
                    ? "d-flex msg-main1 active_chat"
                    : "d-flex msg-main1"
                }
                onClick={() => {
                  handleClick(item);
                  flagFetchHandler(false);
                }}
              >
                <div className="msgpic">
                  <Image
                    loading="lazy"
                    src={item.eu_profile_image ? item.eu_profile_image : Msgpic}
                    className="msgpic"
                  ></Image>
                </div>
                <div className="msg-1">
                  <p className="msg1-text0 text-limit-2">
                    {item.end_user_first_name}
                  </p>
                  <p className="msg1-text1 text-limit-2">{item.product_name}</p>
                  <p className="msg1-text2 text-limit-2">
                    {item.business_name}
                  </p>
                </div>
                {/* <div className="msg-2">
                  <p className="msg2-text1">
                    {Moment(item.created_at).format("HH:MM:SS")}
                  </p>
                  {msg_count[index] > 0 ? (
                    <p className="msg2-text2">{msg_count[index]}</p>
                  ) : null}
                </div> */}
              </div>
            ) : null;
          })
        ) : (
          <p className="NoDataAvailable" style={{ color: "black" }}>
            No data available!
          </p>
        )}
      </div>
    </>
  );
};

OrderRelated.propTypes = {};

export default OrderRelated;
